import { parseData, post } from './common';
export const setAuditFlagStatus = (payload) => post('/InternalAPI/AuditAPI.asmx/SetAuditFlagStatus', {
    Payload: payload
}).then(parseData);
const corpAuditConfigApiPrefix = '/InternalAPI/AuditAPI.asmx';
export const getUserDefList = async () => {
    const result = (await (await post(`${corpAuditConfigApiPrefix}/GetUserDefList`)).json()).d;
    if (result.Status !== 'success') {
        throw new Error(result.Message);
    }
    return JSON.parse(result.Data);
};
export const getGlobalDefLists = async () => {
    const result = (await (await post(`${corpAuditConfigApiPrefix}/GetGlobalDefLists`)).json()).d;
    if (result.Status !== 'success') {
        throw new Error(result.Message);
    }
    return JSON.parse(result.Data);
};
export const getPageloadObject = async () => {
    const result = (await (await post(`${corpAuditConfigApiPrefix}/GetPageloadObject`)).json()).d;
    if (result.Status !== 'success') {
        throw new Error(result.Message);
    }
    return JSON.parse(result.Data);
};
export const saveAuditDef = async (saveAuditDefPayload) => {
    const result = (await (await post(`${corpAuditConfigApiPrefix}/SaveAuditDef`, {
        Payload: saveAuditDefPayload
    })).json()).d;
    if (result.Status !== 'success') {
        throw new Error(result.Message);
    }
    return result;
};
export const getAuditExceptions = async (getAuditExceptionsPayload) => {
    const result = (await (await post(`${corpAuditConfigApiPrefix}/GetAuditExceptions`, {
        Payload: getAuditExceptionsPayload
    })).json()).d;
    if (result.Status !== 'success') {
        throw new Error(result.Message);
    }
    return JSON.parse(result.Data);
};
export const addAuditExceptions = async (addAuditExceptionPayload) => {
    const result = (await (await post(`${corpAuditConfigApiPrefix}/AddAuditExceptions`, {
        Payload: addAuditExceptionPayload
    })).json()).d;
    if (result.Status !== 'success') {
        throw new Error(result.Message);
    }
    return result;
};
export const deleteAuditExceptions = async (deleteAuditExceptionPayload) => {
    const result = (await (await post(`${corpAuditConfigApiPrefix}/DeleteAuditExceptions`, {
        Payload: deleteAuditExceptionPayload
    })).json()).d;
    if (result.Status !== 'success') {
        throw new Error(result.Message);
    }
    return result;
};
export const getAuditAlertsPageload = async () => {
    const result = (await (await post(`${corpAuditConfigApiPrefix}/GetAlertsPageloadObject`)).json()).d;
    if (result.Status !== 'success') {
        throw new Error(result.Message);
    }
    return JSON.parse(result.Data);
};
export const setAuditFlagNotes = async (auditFlagPK, notes) => {
    const result = (await (await post(`${corpAuditConfigApiPrefix}/SetAuditFlagNotes`, {
        Payload: {
            AuditFlagPK: auditFlagPK,
            Notes: notes
        }
    })).json()).d;
    if (result.Status !== 'success') {
        throw new Error(result.Message);
    }
    return result;
};
